import { HardHat } from "lucide-react";
import { Reveal, SectionHead } from "./shared";

const CREDENTIALS = [
  "OSHA 30 (Construction & General Industry)",
  "CPR / First Aid / AED",
  "TSTC: HAZWOPER",
  "TSTC: Construction Safety",
  "TSTC: Environmental Compliance",
  "OSHAcademy: CSHM",
  "OSHAcademy: CSHP",
  "OSHAcademy: CSSS",
  "OSHAcademy: CSHS",
  "OSHAcademy: CSHT",
];

export default function Founder() {
  return (
    <section id="founder" data-testid="founder-section" className="mx-auto max-w-7xl px-5 py-24 lg:px-8 lg:py-32">
      <SectionHead
        index="06"
        overline="Founder"
        title="Sean Rawlins, Founder & CEO"
        note="A safety specialist building the tool he needed in the field."
      />

      <div className="grid grid-cols-1 gap-12 lg:grid-cols-12">
        <Reveal className="lg:col-span-7">
          <div className="flex items-start gap-5">
            <div className="clip-frame flex h-16 w-16 shrink-0 items-center justify-center bg-[#FF5500]/10">
              <HardHat className="h-7 w-7 text-[#FF5500]" strokeWidth={1.6} />
            </div>
            <div>
              <p data-testid="founder-bio" className="text-base leading-relaxed text-slate-300 sm:text-lg">
                Safety Specialist on an 800-MW utility-scale solar project. OSHA 30 (Construction
                &amp; General Industry), CPR/First Aid/AED. TSTC: HAZWOPER and certificates in
                Construction Safety and Environmental Compliance; associate degree in progress.
                OSHAcademy (exam-earned): CSHM, CSHP, CSSS, CSHS, CSHT.
              </p>
              <p className="mt-5 border-l-2 border-[#FF5500] pl-5 text-sm leading-relaxed text-slate-400">
                WorkSafeAgent is founder-managed and built from the field up — every module exists
                because a real jobsite gap demanded it.
              </p>
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.12} className="lg:col-span-5">
          <div className="clip-frame border border-slate-800 bg-[#0D1320] p-7">
            <p className="font-mono text-xs uppercase tracking-[0.25em] text-[#FF5500]">Credentials</p>
            <ul className="mt-5 grid grid-cols-1 gap-x-6 gap-y-3 sm:grid-cols-2">
              {CREDENTIALS.map((c) => (
                <li key={c} className="font-mono text-xs leading-relaxed tracking-wide text-slate-300">
                  {c}
                </li>
              ))}
            </ul>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
